import { useSelector } from 'react-redux';
import { CartesianGrid, ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import styles from './styles.module.scss';
import MetricChartTooltip from './MetricChartTooltip.jsx';
import { MetricChartDotRadius, MetricChartXAxisHeight, MetricChartYAxisWidth } from './constants/index.jsx';
import { MetricChartHeader } from './index.jsx';
import { BreakpointMobile } from '../../constants/ui';
import { ChartColorsMap } from '../Charts/constants/index.jsx';

const ChartTooltip = ({ active, payload, sensor }) => {
  if (!active || !payload || payload.length < 1) return null;
  const value = payload[0].value;
  const valueCompared =
    payload.length > 1
      ? [
          { name: sensor.name, value: `${value}%`, color: ChartColorsMap.leafArea },
          {
            name: sensor.name2,
            value: `${payload[1].value}%`,
            color: ChartColorsMap.leafAreaCompared,
          },
        ]
      : null;
  return value !== null && <MetricChartTooltip value={`${value}%`} comparedData={valueCompared} />;
};

const MetricChartLeafArea = ({ title, data, sensor, widthViewport }) => {
  const { selectedSecondarySensor } = useSelector((state) => state.sensors);

  if (!data) {
    return null;
  }

  return (
    <div className={styles.metricChart}>
      {widthViewport > BreakpointMobile && (
        <MetricChartHeader
          title={title}
          sensorName={sensor.name}
          sensorNameCompared={sensor.name2}
          color={ChartColorsMap.leafArea}
          colorCompared={ChartColorsMap.leafAreaCompared}
        />
      )}

      <ResponsiveContainer width="100%" height={140} className="chart-report">
        <ComposedChart
          width={500}
          height={140}
          data={data.data}
          margin={{
            top: 8,
            right: 8,
            left: 0,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="0 0" stroke={'var(--neutral-8)'} vertical={false} />
          <XAxis dataKey="date" tickLine={false} height={MetricChartXAxisHeight} />
          <YAxis ticks={[0, 50, 100]} tickSize={0} tickMargin={6} width={MetricChartYAxisWidth} domain={[0, 100]} />
          <Tooltip content={<ChartTooltip sensor={sensor} />} />
          <Line
            type="monotone"
            dataKey="value"
            strokeWidth={2}
            stroke={ChartColorsMap.leafArea}
            activeDot={{ r: MetricChartDotRadius, fill: '#fff', stroke: ChartColorsMap.leafArea }}
          />
          {selectedSecondarySensor && (data.data[0].value2 || data.data[0].value2 === 0) && (
            <Line
              type="monotone"
              dataKey="value2"
              strokeWidth={2}
              stroke={ChartColorsMap.leafArea}
              activeDot={{ r: MetricChartDotRadius, fill: '#fff', stroke: ChartColorsMap.leafArea }}
              strokeDasharray="2 2"
            />
          )}
        </ComposedChart>
      </ResponsiveContainer>
      <div className={styles.metricChartUnit}>%</div>
    </div>
  );
};

export default MetricChartLeafArea;
